import React, { Component } from "react";
import TranslationText from "../Translation/TranslationText.jsx";
import PropTypes from "prop-types";
import { Trans } from "react-i18next";

class EmailVerificationSent extends Component {
	render() {
		return <React.Fragment>
			<br />
			<p>
				<Trans
					i18nKey="email_change_success_popup_info1"
					values={{ email: this.props.email }}
					components={{ bold: <strong /> }}
				/>
			</p>
			<br />
			<p>
				<TranslationText text='email_change_success_popup_info2' />
			</p>
		</React.Fragment>
	}
}

export default EmailVerificationSent;

EmailVerificationSent.propTypes = {
	email: PropTypes.string.isRequired
};